module.exports = __webpack_public_path__ + "img/23.5271bcc0.jpg";